import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import catResultPicture from 'img/nestleLanding/cat-block-result.png';
import catResultTopPicture from 'img/nestleLanding/cat-result.png';
import dogResultPicture from 'img/nestleLanding/dog-block-result.png';
import dogResultTopPicture from 'img/nestleLanding/dog-result.png';
import pawsPicture from 'img/nestleLanding/paws-empty-result.png';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { nestleResultListCat, nestleResultListDog } from 'reactApp/appHelpers/featuresHelpers/features/nestle';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { sendNestleLandingAnalytics } from 'reactApp/sections/Nestle/NestleLanding.analytics';
import { Title } from 'reactApp/sections/Nestle/Title/Title';

import styles from './ResultTable.css';

export const ResultTable = memo(() => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    const [isCatTab, setCatTab] = useState<boolean>(true);

    const list = useMemo(() => (isCatTab ? nestleResultListCat : nestleResultListDog), [isCatTab]);

    const onChangeTab = useCallback(() => {
        sendNestleLandingAnalytics({
            eventCategory: 'click',
            action: `click-${isCatTab ? 'dogs' : 'cats'}-results`,
        });
        setCatTab(!isCatTab);
    }, [isCatTab]);

    const content = useMemo(() => {
        if (list) {
            return (
                <div className={styles.content_list}>
                    {list.map(({ type, names }, index) => (
                        <div key={`block-${index}`}>
                            <div className={styles.type}>{type}</div>
                            <Spacing size={isMobile ? 15 : 20} />
                            <div className={styles.names}>
                                {names.map((name, index) => (
                                    <div key={`name-${index}`}>{name}</div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        return (
            <div className={styles.content_empty}>
                Крошка, Морсик, Бобби, Попс!
                <br />
                Собираем первые клички и вот-вот обновим результаты —&nbsp;возвращайтесь чуть позже
            </div>
        );
    }, [isCatTab, list, isMobile]);

    if (isMobile) {
        return (
            <div className={styles.container}>
                <Title title="результаты переклички" />
                <Spacing size={24} />
                <div
                    className={classNames(styles.root, {
                        [styles.root_mobile]: isMobile,
                        [styles.root_mobile_cat]: isCatTab,
                    })}
                >
                    <div className={styles.tabs_mobile} onClick={onChangeTab}>
                        <div className={styles.tab}>собаки</div>
                        <div className={styles.tab}>кошки</div>
                    </div>
                    {content}
                    {!list && <img src={pawsPicture} alt="" className={styles.img_empty} />}
                </div>
                <Spacing size={12} />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <Title title="результаты переклички" />
            <Spacing size={60} />
            <div className={styles.root}>
                <div
                    className={classNames(styles.tabs, {
                        [styles.tabs_right]: !isCatTab,
                    })}
                >
                    {isCatTab && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="431" height="88" viewBox="0 0 431 88" fill="none">
                            <path
                                d="M0.25 40C0.25 17.9086 18.1586 0 40.25 0H363.547C381.22 0 395.547 14.3269 395.547 32C395.547 49.6731 409.874 64 427.547 64H430.25L0.25 88V40Z"
                                fill="white"
                            />
                        </svg>
                    )}

                    {!isCatTab && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="390" height="88" viewBox="0 0 390 88" fill="none">
                            <path
                                d="M390 40C390 17.9086 372.091 0 350 0H63.4752C45.8021 0 31.4751 14.5915 31.4751 32.2646C31.4751 49.6478 17.3832 64 0 64L390 88V40Z"
                                fill="white"
                            />
                        </svg>
                    )}

                    <div className={styles.tabsText}>
                        <div
                            className={classNames(styles.cat, {
                                [styles.tab_clickable]: !isCatTab,
                            })}
                            onClick={onChangeTab}
                        >
                            Кошки
                        </div>
                        <div
                            className={classNames(styles.dog, {
                                [styles.tab_clickable]: isCatTab,
                            })}
                            onClick={onChangeTab}
                        >
                            Собаки
                        </div>
                    </div>
                </div>
                <div className={styles.contentBlock}>
                    <div
                        className={classNames(styles.content, {
                            [styles.active_left]: isCatTab,
                            [styles.active_right]: !isCatTab,
                        })}
                    >
                        {content}
                    </div>
                </div>
                {Boolean(list) && <img src={isCatTab ? catResultTopPicture : dogResultTopPicture} alt="" className={styles.img_top} />}
                <img src={isCatTab ? catResultPicture : dogResultPicture} alt="" className={styles.img} />
            </div>
            <Spacing size={100} />
        </div>
    );
});

ResultTable.displayName = 'ResultTable';
